import { useGraphqlQuery } from "@harea/component";
import { TContract } from "@harea/component";
import { EmployeeOrganisationQuery } from "../query/EmployeeOrganisationQuery";

export const useEmployeeOrganisationQuery = (employeeId?: number) => {
    return useGraphqlQuery<EmployeeOrganisationQuery, TContract | null>(
        new EmployeeOrganisationQuery({ employeeId }),
        { enabled: !!employeeId && employeeId !== -1 }
    );
};
